import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvironmentConfig } from '../../interfaces/environment.interface';
import {
  GetSupplierResponse,
  SupplierBlend,
  PostBlockSupplierResponse,
  UpdateSupplierRequest,
  UpdateSupplierBlendReq,
  GetFusionSupplierResponse,
  PatchFusionSupplierRequest,
  PatchFusionSupplierResponse,
  SupplierGroupTemplateResponseInterface,
} from './manage-suppliers.interface';
import {
  BlendSupplier,
  EachSupplierWithGroupName,
} from '../../interfaces/survey.interface';

@Injectable({
  providedIn: 'root',
})
export class ManageSuppliersService {
  private readonly _baseUrl = this._env.environment.pureSpectrum.url;
  private readonly _fusionUrl = this._env.environment.FUSION_API_URL;

  constructor(
    private _http: HttpClient,
    @Inject('ENV') private _env: EnvironmentConfig
  ) {}

  getSuppliers(id: number, country?: number, language?: number) {
    let url = `${this._baseUrl}/getSupplier/${id}`;
    if (country && language) {
      url = `${url}?country=${country}&language=${language}`;
    }
    return this._http.get<GetSupplierResponse>(url);
  }
  updateBlockedSuppliers(data: UpdateSupplierRequest) {
    return this._http.post<PostBlockSupplierResponse>(
      `${this._baseUrl}/preferedSupplierList`,
      data
    );
  }

  updateSupplierBlends(supplierBlendId: string, data: any) {
    return this._http.put<UpdateSupplierBlendReq>(
      `${this._baseUrl}/buyers/v2/supplier-blends/${supplierBlendId}`,
      data
    );
  }

  createSupplierBlends(data: any) {
    return this._http.post<UpdateSupplierBlendReq>(
      `${this._baseUrl}/buyers/v2/supplier-blends`,
      data
    );
  }
  getSupplierBlends() {
    return this._http.get<SupplierBlend[]>(
      `${this._baseUrl}/buyers/v2/supplier-blends`
    );
  }

  deleteSupplierBlends(supplierBlendId: string) {
    return this._http.delete(
      `${this._baseUrl}/buyers/v2/supplier-blends/${supplierBlendId}`
    );
  }

  setBlendAsDefault(supplierBlendId: string, isDefault: boolean) {
    return this._http.patch(
      `${this._baseUrl}/buyers/v2/supplier-blends/set-default/${supplierBlendId}/${isDefault}`,
      ''
    );
  }

  getFusionSuppliers(id: number) {
    return this._http.get<GetFusionSupplierResponse>(
      `${this._fusionUrl}/blockedSuppliersPs/${id}`,
      {
        headers: {
          skipInterceptor: 'true',
          'access-token': 'aabrakadabra',
        },
      }
    );
  }

  updateBlockedFusionSuppliers(id: number, data: PatchFusionSupplierRequest) {
    return this._http.patch<PatchFusionSupplierResponse>(
      `${this._fusionUrl}/syncSettings/${id}/blockedSuppliersPs`,
      data,
      {
        headers: {
          skipInterceptor: 'true',
          'access-token': 'aabrakadabra',
        },
      }
    );
  }

  saveGroupAsTemplate(payload: SupplierGroupTemplateResponseInterface) {
    return this._http.post<SupplierGroupTemplateResponseInterface>(
      `${this._baseUrl}/buyers/v2/supplier-group-template`,
      payload
    );
  }

  getAllGroupTemplates() {
    return this._http.get<SupplierGroupTemplateResponseInterface[]>(
      `${this._baseUrl}/buyers/v2/supplier-group-template`
    );
  }

  getBlendSupplierIds(
    blend: BlendSupplier | EachSupplierWithGroupName
  ): number[] {
    const blendSupplierIds = blend.supplier_id;
    return blendSupplierIds.map((s) => s.id);
  }

  lockBlends(blendIds: string[], isLocked: boolean) {
    return this._http.patch(
      `${this._baseUrl}/buyers/v2/supplier-blends/set-locked`,
      { blendIds, isLocked }
    );
  }
}
